

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  message: '',
  phone: "",
  isSubmitted: false,  // מצב חדש לניהול האם הטופס נשלח
  messages: [],
  handledMessages: [],
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    }
    ,
    deleteMessage: (state, action) => {
      const id = action.payload;
      state.messages = state.messages.filter(m => m.id !== id);
    },

    clearForm: (state) => {
      state.name = '';
      state.email = '';
      state.phone = "";
      state.message = '';
    },
    setIsSubmitted: (state, action) => {  // פעולה לניהול מצב השליחה
      state.isSubmitted = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    markMessageHandled: (state, action) => {
      const id = action.payload;

      // מוצאים את ההודעה
      const msgIndex = state.messages.findIndex(m => m.id === id);
      if (msgIndex === -1) return;

      const msg = state.messages[msgIndex];

      // מעבירים לטופלו
      state.handledMessages.push(msg);

      // מסירים מהרשימה הראשית
      state.messages.splice(msgIndex, 1);
    },

  },
});

export const { setName, setEmail, setPhone, setMessage, clearForm, setIsSubmitted, deleteMessage, setMessages, markMessageHandled } = contactSlice.actions;
export default contactSlice.reducer;
